import React, { forwardRef, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import normalizeCSSModules from '../../utils/css-modules';
import styles from './button.module.css';
import { useGroup } from '../group/utils';
import { getIconProps } from './utils';
const s = normalizeCSSModules(styles);
const colorAliases = {
    'brand-purple': 'promo1',
    'brand-turquoise': 'promo2',
};
const Button = forwardRef((props, ref) => {
    const { children, circle = false, dataAttrs = {}, dataTest, disabled = false, fullWidth = false, gtm, href, rel, target, iconColor, iconPosition = 'start', loading = false, onClick, overflow = true, rounded = 'all', selected = false, shadow = false, size: externalSize = 'm', type = 'button', width, form, } = props;
    let { block = false, variant = 'primary' } = props;
    const group = useGroup();
    const size = (group.present && group.size) || externalSize;
    const clearedDataAttrs = useMemo(() => {
        return Object.keys(dataAttrs).reduce((res, dataKey) => {
            if (/^data-+./.test(dataKey)) {
                res[dataKey] = dataAttrs[dataKey];
            }
            return res;
        }, {});
    }, [dataAttrs]);
    const handleClick = useCallback(event => {
        if (disabled) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [onClick, disabled]);
    block = block || fullWidth;
    variant = variant in colorAliases ? colorAliases[variant] : variant;
    const iconProps = getIconProps(props);
    const link = !disabled && !!href;
    const ButtonTag = link ? 'a' : 'button';
    const specificProps = link ? { href, target, rel } : { form, type };
    return (React.createElement(ButtonTag, Object.assign({ onClick: handleClick, disabled: disabled || loading, className: classNames(s.control, s[variant], s[size], selected && s.selected, loading && s.loading, shadow && s.shadow, block && s.block, circle && s.circle, !!width && block && s.bounded, {
            [s.roundedLeft]: (group.present && group.first) || (!group.present && (rounded === 'all' || rounded === 'left')),
            [s.roundedRight]: (group.present && group.last) || (!group.present && (rounded === 'all' || rounded === 'right')),
        }), ref: ref, "data-test": dataTest, "data-gtm": gtm }, clearedDataAttrs, { style: Object.assign(Object.assign({ width }, (group.present && { flex: group.width })), (group.present && { maxWidth: group.maxWidth })) }, specificProps),
        iconProps && iconPosition === 'start' && (React.createElement("span", { className: classNames(s.icon, s.start, !children && s.only), style: Object.assign({}, (iconColor && { color: iconColor })) },
            React.createElement(Icon, Object.assign({}, iconProps)))),
        React.createElement("span", { "data-gtm": gtm, className: classNames(s.content, overflow && s.overflow) }, children),
        iconProps && iconPosition === 'end' && (React.createElement("span", { className: classNames(s.icon, s.end, !children && s.only), style: Object.assign({}, (iconColor && { color: iconColor })) },
            React.createElement(Icon, Object.assign({}, iconProps)))),
        loading && (React.createElement("span", { className: s.loader },
            React.createElement("span", { className: s.loaderSvg },
                React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { fill: "currentColor", d: "M8 2a6 6 0 00-6 6 1 1 0 01-2 0 8 8 0 018-8 1 1 0 010 2z" })))))));
});
export default Button;
//# sourceMappingURL=button.js.map